module.exports = __webpack_public_path__ + "img/icon_证书_B级赛事@3x.387856f4.png";